/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Storage_UnavailableInputs */

const en_error_storage_unavailable = /** @type {(inputs: Error_Storage_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file could not be stored right now. Try again in a moment.`)
};

/**
* | output |
* | --- |
* | "The file could not be stored right now. Try again in a moment." |
*
* @param {Error_Storage_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_storage_unavailable = /** @type {((inputs?: Error_Storage_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Storage_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_storage_unavailable(inputs)
});